export const SET_CURRENT = `SET_CURRENT`;
export const SET_FIELD = `SET_FIELD`;
export const SET_SERVICES = `SET_SERVICES`;

export const SWITCH_LANGUAGE = `SWITCH_LANGUAGE`;
